import type { LibrarySearchItem } from "../../../api/content/searchApi";
import Chip from "../../../ui/feedback/Chip";
import HighlightedSnippet from "../query/HighlightedSnippet";

/** A found item's content type and the text around its match, under the item's name. */
export default function LibraryHitDetail({ item }: { item: LibrarySearchItem }) {
  return (
    <>
      {item.contentType === null ? null : <Chip size="compact">{item.contentType}</Chip>}
      {item.snippet === null ? null : <HighlightedSnippet snippet={item.snippet} />}
    </>
  );
}
